export const ERROR_MESSAGES = {
    DEFAULT: ' Something went wrong',
    VALID_EMAIL: 'Please enter a valid email.',
    REQUIRED_FIELD_MISSING: 'Required field is missing.',
    INVALID_PHONE_NUMBER: "Oops! That phone number doesn't look right",
    PASSWORD_DO_NOT_MATCH: "Oops! Your passwords aren't matching up",
    PASSWORD_CHAR_LIMIT: '8-20 characters',
    PASSWORD_LOWERCASE: 'At least one lowercase character',
    PASSWORD_UPPERCASE: 'At least one uppercase character',
    PASSWORD_DIGIT: 'At least one number',
    PASSWORD_SPECIAL_CHAR: 'At least one special character: ‘~!@#$%^&*()_+=-',
    PASSWORD_NO_SPACES: `No spaces`,
    MAX_INSURANCE_LIMIT: 'Max limit of insurance entries reached',
    INSURANCE_ALREADY_EXIST: 'This insurance is already on file',
    MEDICATION_IS_ALREADY_EXIST: 'This medication has already been added',
    INVALID_VERIFICATION_CODE:
        'Verification code is invalid or has timed out. Please click the “Resend Verification Code” button at the bottom of the page.',
    INVALID_VERIFICATION_CODE_POPUP: `Verification code is invalid or has timed out. Please click the “I didn’t receive a code” button at the bottom of the popup.`,
    INVALID_VERIFICATION_CODE_KEY:
        'Verification code is invalid or has timed out. Please click the “Resend Verification Code” button at the bottom of the page.',
    EMAIL_NOT_REGISTERED: 'Email is not registered with us.',
    LOGIN_CREDENTIALS_ERROR: 'Wrong email or password',
    EMAIL_REGISTERED: "This email is already registered. Please click 'Log in to Existing Account",
    SERVER_ERROR: 'Oops! Something went wrong',
    FILL_FIELDS_CORRECT: 'Something went wrong! Please fill out all fields correctly',
    CANNOT_CHANGE_ADDRESS_AT_THIS_TIME: "Address changes can't be made right now. You can update it after delivery!",
    NOT_VERIFIED_ACCOUNT: 'This account has not been verified. Verification code resent.', // Copied from backend error message
    ADD_PAYMENT_METHOD_FAILED: 'There is a problem with this card. Please verify the card details and billing address are correct.',
    CARD_ALREADY_ASSOCIATED: 'Card is already associated with user'
};
